<script setup>

import { defineProps, ref, computed, watch, defineEmits } from 'vue';
import MultiSelect from 'vue-multiselect';

const props = defineProps({
    filterType: {
        type: Object,
        default: () => ({})
    },
})

const filterType = ref(props.filterType);

const options = computed(() => {
    return filterType.value.items.map((item, index) => {
        if (item.name) {
            return {
                name: item.name,
                id: index
            };
        }
    });
});

const selectedFilters = defineModel('selectedFilters');

const isMobile = ref(window.innerWidth <= 992);

window.addEventListener('resize', () => {
    isMobile.value = window.innerWidth <= 992;
});

const isOpen = ref(false);

const multiSelectRef = ref(null);

function toggle() {
    if (isOpen.value) {
        multiSelectRef.value.deactivate();
        isOpen.value = false;
    } else {
        multiSelectRef.value.activate();
        isOpen.value = true;
    }
}

function handleClickOutside(event) {
    if (multiSelectRef.value && !multiSelectRef.value.$el.contains(event.target)) {
        isOpen.value = false;
    }
}

document.addEventListener('click', handleClickOutside);

</script>

<template>
    <div class="m-articles-filter__title">
        {{ filterType.name }}
    </div>
    <div class="m-articles-filter__group" v-if="isMobile">
        <div v-for="option in options" :key="option.id" class="m-articles-filter__type">
            <input type="checkbox" :id="option.name" :value="option" v-model="selectedFilters">
            <label :for="option.name">{{ option.name }}</label>
        </div>
    </div>

    <multi-select v-else ref="multiSelectRef" class="m-articles-filter__type" id="multiselect" :options="options"
        :multiple="true" :close-on-select="false" :clear-on-select="false" :searchable="false" label="name"
        track-by="name" :preselect-first="false" placeholder="" v-model="selectedFilters" @click="toggle">
        <template #selection="{ values, isOpen }">
            <div class="multiselect__select">
                {{ values.length > 0 ? "[" + values.length + "]" : "" }} {{ filterType.name }}
                <svg class="icon icon-chevron">
                    <use xlink:href="#icon-chevron"></use>
                </svg>
            </div>
        </template>
    </multi-select>
</template>